import React, { useState, useEffect, useRef } from 'react'

import apiFetch from '@wordpress/api-fetch'
import './styles.scss'
import useAnimation from './useAnimation'

export default function RoadmapBlock({
  legend_done_text,
  legend_warning_text,
  legend_cancel_text,
}) {
  const [postData, setPostData] = useState([])
  const ref = useRef()
  useAnimation(postData, ref)

  const lang = document.documentElement.lang

  useEffect(() => {
    apiFetch({
      path:
        lang === 'en-US'
          ? '/en/wp-json/wp/v2/roadmap?order=asc&orderbyacf=year'
          : '/wp-json/wp/v2/roadmap?order=asc&orderbyacf=year',
    }).then(data => {
      setPostData(data)
    })
  }, [])

  return (
    <div className={'dhsv-roadmap'} ref={ref}>
      <BubbleRef />
      <div className="legend">
        <div className="legende-item done">
          <StatusIcon status="done" />
          <p>{legend_done_text}</p>
        </div>
        <div className="legende-item warning">
          <StatusIcon status="warning" />
          <p>{legend_warning_text}</p>
        </div>
        <div className="legende-item cancel">
          <StatusIcon status="cancel" />
          <p>{legend_cancel_text}</p>
        </div>
      </div>
      <div className="startpoint">
        <svg
          className="frame"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 220.197 184.92"
        >
          <path
            d="M224.174,394.275a108.6,108.6,0,1,1,160.883,1.7"
            transform="translate(-195.289 -212.079)"
            fill="none"
          />
        </svg>
        <svg
          className="start-feet"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 84.8 56.8"
        >
          <g className={`foot-bottom`}>
            <path
              className="svg-small-roadmap-feet"
              d="M65.3,51.6c0.5,0.6,1.3,0.7,1.9,0.3c0.4-0.7,0.2-1.7-0.6-2.1c-0.4-0.3-1-0.2-1.5,0
	                C64.6,50.4,64.8,51.2,65.3,51.6"
            />
            <path
              className="svg-small-roadmap-feet"
              d="M68.4,49.2c0.7,0.6,1.6,0.5,2.2-0.1c0.3-0.8,0-1.7-0.7-2.2c-0.7-0.6-1.6-0.5-2.2,0.1
	                C67.2,47.9,67.6,48.8,68.4,49.2"
            />
            <path
              className="svg-small-roadmap-feet"
              d="M71.7,46.2c1.1,0.4,2.3-0.2,2.7-1.4c0-1.2-0.8-2.2-2.1-2.3c-1.1-0.4-2.3,0.2-2.7,1.4
	                C69.6,45.1,70.5,46,71.7,46.2"
            />
            <path
              className="svg-small-roadmap-feet"
              d="M74.2,41.8c1.6,0.3,3.2-0.5,3.4-1.7c0.3-1.2-0.9-2.4-2.6-2.7s-3.2,0.5-3.4,1.7
	                C71.4,40.2,72.5,41.4,74.2,41.8"
            />
            <path
              className="svg-small-roadmap-feet"
              d="M74.8,36.1c2.7,0.6,5-0.4,5.4-2.3c0.4-1.9-1.3-3.9-3.9-4.5c-2.7-0.6-5,0.4-5.4,2.3
	                C70.5,33.5,72.2,35.5,74.8,36.1"
            />
            <path
              className="svg-small-roadmap-feet"
              d="M68.4,30.9c-1-1.2-4.5-4.8-16.6,5.2c-0.8,0.5-1.6,0.9-2.5,1.1c-1.4,0.1-2.8-0.2-4-0.9
	                c-3.1-1.7-8.9-3.3-12.1-0.6c-1.8,1.5-2.3,4.9-1.3,7.2c1.6,3.7,6.8,5.8,12.4,3.8c2.7-0.9,5.6-0.4,7.7,1.3c4.5,2.7,11,3.6,13.9-0.3
	                C68.8,43.5,73.3,36.3,68.4,30.9"
            />
          </g>
          <g className={`foot-top`}>
            <path
              className="svg-small-roadmap-feet"
              d="M36,3.3c0.4-0.7,1.1-0.9,1.8-0.7c0.5,0.5,0.5,1.3,0.1,1.8c-0.4,0.7-1.1,0.9-1.8,0.7
	                C35.6,4.7,35.4,3.9,36,3.3"
            />
            <path
              className="svg-small-roadmap-feet"
              d="M39.5,5.2c0.6-0.7,1.5-0.8,2.3-0.3c0.5,0.8,0.4,1.7-0.4,2.2c-0.6,0.7-1.5,0.8-2.3,0.3
	                C38.6,6.8,38.7,5.8,39.5,5.2"
            />
            <path
              className="svg-small-roadmap-feet"
              d="M43.2,7.6c1.1-0.6,2.3-0.1,3,0.8c0.3,1.2-0.5,2.3-1.6,2.6c-1.1,0.6-2.3,0.1-3-0.8
	              C41.4,9.1,42,7.9,43.2,7.6"
            />
            <path
              className="svg-small-roadmap-feet"
              d="M46.6,11.5c1.6-0.6,3.2-0.2,3.6,1.1c0.4,1.1-0.5,2.5-2,3.1c-1.6,0.6-3.2,0.2-3.6-1.1
	                C44.2,13.4,45,12.1,46.6,11.5"
            />
            <path
              className="svg-small-roadmap-feet"
              d="M48.2,16.9c2.5-1.1,5-0.5,5.7,1.3s-0.6,4-3.1,5.1c-2.5,1.1-5,0.5-5.7-1.3
	                C44.5,20.3,45.8,18,48.2,16.9"
            />
            <path
              className="svg-small-roadmap-feet"
              d="M42.9,23.2c-0.8,1.3-3.6,5.6-17.3-2c-0.8-0.4-1.7-0.6-2.6-0.5c-1.4,0.1-2.6,0.7-3.8,1.6
	                c-2.7,2.3-8.1,4.9-11.7,2.8c-2-1.1-3.2-4.4-2.6-6.9c0.7-3.8,5.5-6.9,11.3-5.9c1.2,0.2,2.4,0.1,3.6-0.3c1.4-0.5,2.7-1.3,3.7-2.5
	                C27.4,6,33.6,4,37.2,7.3S46.7,17.1,42.9,23.2"
            />
          </g>
        </svg>
      </div>
      {postData.map((item, i, postData) => (
        <div
          className={'roadmap-entry'}
          key={item.id}
          id={'roadmap-' + item.id}
        >
          <div
            className={`year-container year-container-${
              item.fields.title_left ? 'double' : 'single'
            } ${item.fields.grey ? 'grey' : ''}`}
          >
            <Bubbles />
            <div
              className="year"
              id={`${item.fields.anchor ? item.fields.anchor : ''}`}
            >
              {i + 1 === postData.length ? (
                <div className="endpoint mobile">
                  <svg
                    className="frame"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 220.197 184.92"
                  >
                    <path
                      d="M224.174,394.275a108.6,108.6,0,1,1,160.883,1.7"
                      transform="translate(-195.289 -212.079)"
                      fill="none"
                    />
                  </svg>
                  <svg
                    className="end-flag"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40.9 41.8"
                  >
                    <rect x="2" y="2.4" width="3.7" height="38.1" />
                    <path d="M39.4,2.5H7.7v25.2h31.6l-8.6-12.6L39.4,2.5z" />
                  </svg>
                </div>
              ) : null}
              <div className="year-title">{item.fields.year}</div>
              <div className={`year-boxes`}>
                {item.fields.title_left && (
                  <div className="year-box-container left">
                    <div className={`year-box`}>
                      <div className={`preview`}>
                        <StatusIcon status={item.fields.status_left} />
                        <div className="preview-wrapper">
                          <div className="title">{item.fields.title_left}</div>
                          <div className="intro">{item.fields.intro_left}</div>
                        </div>
                      </div>
                      <button className="open-button">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 60 60"
                        >
                          <rect x="14.9" y="26.7" width="30" height="7" />
                          <rect
                            x="26.4"
                            y="15.2"
                            className="horizontal"
                            width="7"
                            height="30"
                          />
                        </svg>
                      </button>

                      <div className="full-text">
                        {item.fields.image_left && (
                          <div className="image-holder">
                            {item.fields.image_left.mime_type.includes(
                              'image'
                            ) ? (
                              <img
                                src={item.fields.image_left.sizes.medium_large}
                                alt={item.fields.image_left.alt}
                              />
                            ) : (
                              <>
                                <div
                                  className="video desktop"
                                  dangerouslySetInnerHTML={{
                                    __html: `<video playsinline loop muted autoplay>
                                <source src=${item.fields.image_left.url} type="video/mp4" />
                                </video>`,
                                  }}
                                />
                                <div
                                  className="video mobile"
                                  dangerouslySetInnerHTML={{
                                    __html: `<video playsinline loop muted autoplay>
                                <source src=${item.fields.image_left.url} type="video/mp4" />
                                </video>`,
                                  }}
                                />
                              </>
                            )}
                          </div>
                        )}

                        <div
                          className="text-content"
                          dangerouslySetInnerHTML={{
                            __html: item.fields.content_left,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {item.fields.title ? (
                  <div className="year-box-container right">
                    <div className={`year-box`}>
                      <div className={`preview`}>
                        <div className="preview-wrapper">
                          <StatusIcon status={item.fields.status} />
                          <div className="title">{item.fields.title}</div>
                          <div className="intro">{item.fields.intro}</div>
                        </div>
                      </div>
                      <button className="open-button">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 60 60"
                        >
                          <rect
                            x="14.9"
                            y="26.7"
                            className="plus-icon-svg-2"
                            width="30"
                            height="7"
                          />
                          <rect
                            x="26.4"
                            y="15.2"
                            className="horizontal"
                            width="7"
                            height="30"
                          />
                        </svg>
                      </button>

                      <div className="full-text">
                        {item.fields.image && (
                          <div className="image-holder">
                            {item.fields.image.mime_type.includes('image') ? (
                              <img
                                src={item.fields.image.sizes.medium_large}
                                alt={item.fields.image.alt}
                              />
                            ) : (
                              <>
                                <div
                                  className="video desktop"
                                  dangerouslySetInnerHTML={{
                                    __html: `<video playsinline loop muted autoplay>
                                <source src=${item.fields.image.url} type="video/mp4" />
                                </video>`,
                                  }}
                                />
                                <div
                                  className="video mobile"
                                  dangerouslySetInnerHTML={{
                                    __html: `<video playsinline loop muted autoplay>
                                <source src=${item.fields.image.url} type="video/mp4" />
                                </video>`,
                                  }}
                                />
                              </>
                            )}
                          </div>
                        )}

                        <div
                          className="text-content"
                          dangerouslySetInnerHTML={{
                            __html: item.fields.content,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="year-box-container placeholder"></div>
                )}
              </div>
              {i + 1 === postData.length ? (
                <div className="endpoint desktop">
                  <svg
                    className="frame"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 220.197 184.92"
                  >
                    <path
                      d="M224.174,394.275a108.6,108.6,0,1,1,160.883,1.7"
                      transform="translate(-195.289 -212.079)"
                      fill="none"
                    />
                  </svg>
                  <svg
                    className="end-flag"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40.9 41.8"
                  >
                    <rect x="2" y="2.4" width="3.7" height="38.1" />
                    <path d="M39.4,2.5H7.7v25.2h31.6l-8.6-12.6L39.4,2.5z" />
                  </svg>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

const StatusIcon = ({ status }) => {
  switch (status) {
    case 'warning':
      return (
        <div className={`status-icon ${status}`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.1 43">
            <style type="text/css">
              {`
              .st0-warning{fill:#FFD103;}
              .st1-warning{fill:#FFFFFF;}
              `}
            </style>
            <circle className="st0-warning" cx="22" cy="21.4" r="20" />
            <path
              className="st1-warning"
              d="M22,6.8L7.9,29.7H36L22,6.8z M20.2,13.5h3.4v9.3h-3.4V13.5z M20.2,27.4v-3.3h3.5v3.3H20.2z"
            />
          </svg>
        </div>
      )

    case 'cancel':
      return (
        <div className={`status-icon ${status}`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.1 43">
            <style type="text/css">
              {`
                .st0-cancel{fill:none;}
                .st1-cancel{fill:#9C2744;}
                .st2-cancel{fill:#FFFFFF;}
              `}
            </style>
            <rect x="2" y="1.5" className="st0-cancel" width="40" height="40" />
            <path
              className="st1-cancel"
              d="M21.9,1.5c-11,0-19.9,9-19.9,20s8.9,19.9,19.9,19.9s20-8.9,20-19.9S33,1.5,21.9,1.5L21.9,1.5"
            />
            <path
              className="st2-cancel"
              d="M25.3,21.2l8.2,8.2l-3.3,3.3l-8.3-8.2l-8.2,8.2l-3.3-3.3l8.2-8.2L10.4,13l3.3-3.3l8.2,8.2
              l8.2-8.2l3.3,3.3L25.3,21.2z"
            />
          </svg>
        </div>
      )

    case 'done':
      return (
        <div className={`status-icon ${status}`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.1 43">
            <style type="text/css">
              {`
                .st0-done{fill - rule:evenodd;clip-rule:evenodd;fill:#7AB929;}
                .st1-done{fill:#FFFFFF;}
              `}
            </style>
            <path
              className="st0-done"
              d="M22,1.5c-11,0-20,9-20,20s9,20,20,20s20-9,20-20l0,0C42,10.5,33,1.5,22,1.5z"
            />
            <rect
              x="13.5"
              y="12.7"
              className="st1-done"
              width="1.9"
              height="18.9"
            />
            <path
              className="st1-done"
              d="M32.7,12.5H17V25h15.8l-4.3-6.3L32.7,12.5z"
            />
          </svg>
        </div>
      )

    default:
      return <div className={`status-icon ${status}`} />
  }
}

const BubbleRef = () => {
  return (
    <svg
      className="bubbles-reference"
      width="0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 49 166"
    >
      <defs>
        <symbol id="foot-left" viewBox="0 -1 17.505 35">
          <g>
            <path d="M1.313,23.005c-2.673-4.662,1.515-7.22.738-11.969C1.715,8.976-2.414,3.742,3.1.582a4.4,4.4,0,0,1,6,1.626c1.7,2.966-.736,7.193-.438,9.545.4,3.15,4.855,4.536,6.83,8.472a4.709,4.709,0,0,1-1.5,6.213C10.381,28.5,3.619,27.031,1.313,23.005Z" />
            <ellipse
              cx="14.982"
              cy="30.423"
              rx="3.529"
              ry="2.523"
              transform="translate(-15.483 45.32) rotate(-89.838)"
            />
            <ellipse
              cx="9.97"
              cy="30.573"
              rx="2.242"
              ry="1.603"
              transform="translate(-20.631 40.456) rotate(-89.838)"
            />
            <ellipse
              cx="6.06"
              cy="29.155"
              rx="1.696"
              ry="1.213"
              transform="translate(-23.112 35.132) rotate(-89.838)"
            />
            <path d="M2.413,27.31c.282-.638.88-.993,1.337-.791a1.129,1.129,0,0,1,.316,1.521c-.282.638-.881.992-1.337.791A1.132,1.132,0,0,1,2.413,27.31Z" />
            <path d="M.153,25.344a.945.945,0,0,1,1.2-.541,1.059,1.059,0,0,1-.946,1.833A.945.945,0,0,1,.153,25.344Z" />
          </g>
        </symbol>
        <symbol id="foot-right" viewBox="0 -1 19.787 36">
          <g>
            <path d="M17.1,18.564c0-5.374-4.906-5.51-6.6-10.015C9.774,6.6,10.751,0,4.4,0A4.4,4.4,0,0,0,0,4.4c0,3.42,4.218,5.873,5.13,8.061,1.221,2.931-1.954,6.351-1.71,10.747a4.712,4.712,0,0,0,4.4,4.641C11.972,27.846,17.1,23.205,17.1,18.564Z" />
            <ellipse
              cx="8.936"
              cy="31.801"
              rx="2.523"
              ry="3.529"
              transform="translate(-14.703 8.728) rotate(-30)"
            />
            <ellipse
              cx="13.358"
              cy="29.435"
              rx="1.603"
              ry="2.242"
              transform="translate(-12.928 10.623) rotate(-30)"
            />
            <ellipse
              cx="16.045"
              cy="26.26"
              rx="1.213"
              ry="1.696"
              transform="translate(-10.981 11.541) rotate(-30)"
            />
            <path d="M18.29,22.846a1.128,1.128,0,0,0-1.553-.021,1.336,1.336,0,0,0,2.036,1.5A1.13,1.13,0,0,0,18.29,22.846Z" />
            <path d="M19.273,20.016a.841.841,0,1,0,.421,1.248A.944.944,0,0,0,19.273,20.016Z" />
          </g>
        </symbol>
        <linearGradient
          id="bubble-roadmap-gradient"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#93278f" />
          <stop offset="100%" stopColor="#d9d5c9" />
        </linearGradient>
      </defs>
      <g className="bubbles-pattern">
        <circle cx="31.5" cy="6.5" r="2" data-size="2" data-is-animated="0" />
        <circle cx="15.5" cy="7.5" r="4" data-size="4" data-is-animated="0" />
        <circle cx="34" cy="22" r="8" data-size="8" data-is-animated="0" />
        <circle cx="20.5" cy="22.5" r="2" data-size="2" data-is-animated="0" />
        <circle cx="10" cy="37" r="6.5" data-size="6.5" data-is-animated="0" />
        <circle cx="34.5" cy="37.5" r="3" data-size="3" data-is-animated="0" />
        <circle cx="21.5" cy="46.5" r="2" data-size="2" data-is-animated="0" />
        <circle cx="44.5" cy="51.5" r="2" data-size="2" data-is-animated="0" />
        <circle cx="29.5" cy="58.5" r="4" data-size="4" data-is-animated="0" />
        <circle cx="37.5" cy="61.5" r="2" data-size="2" data-is-animated="0" />
        <circle cx="17.5" cy="67.5" r="5" data-size="5" data-is-animated="0" />
        <circle cx="32" cy="85" r="8" data-size="8" data-is-animated="0" />
        <circle cx="19.5" cy="91.5" r="3" data-size="3" data-is-animated="0" />
        <circle cx="18" cy="111" r="6.5" data-size="6.5" data-is-animated="0" />
        <circle cx="29.5" cy="117.5" r="3" data-size="3" data-is-animated="0" />
        <circle cx="34.5" cy="129.5" r="4" data-size="4" data-is-animated="0" />
        <circle cx="23.5" cy="133.5" r="2" data-size="2" data-is-animated="0" />
        <circle cx="6.5" cy="140.5" r="4" data-size="4" data-is-animated="0" />
        <circle cx="26" cy="155" r="8" data-size="8" data-is-animated="0" />
        <circle
          cx="10.75"
          cy="154.75"
          r="3.5"
          data-size="3.5"
          data-is-animated="0"
        />
      </g>
    </svg>
  )
}

const Bubbles = () => {
  return (
    <svg
      className="bubbles"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 0 0"
    >
      <g className="bubbles-container"></g>
      <use
        className="foot"
        xlinkHref="#foot-left"
        x="9"
        y="-37"
        width="17.505"
        height="33.952"
      />
      <use
        className="foot"
        xlinkHref="#foot-right"
        x="21"
        y="-58"
        width="19.787"
        height="35.108"
      />
    </svg>
  )
}
